var render = function render(){var _vm=this,_c=_vm._self._c;return _c('birth-form',{attrs:{"birth":_vm.birth},on:{"processBirth":_vm.addBirth}})
}
var staticRenderFns = []

export { render, staticRenderFns }